import CryptoJS from "crypto-js";

// Constants
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || '';
const SALT_KEY =  process.env.REACT_APP_SALT_KEY || '';
const ITERATION_COUNT = 10;
const KEY_LENGTH = 256;

function deriveKey(): CryptoJS.lib.WordArray {
  return CryptoJS.PBKDF2(SECRET_KEY, CryptoJS.enc.Utf8.parse(SALT_KEY), {
    keySize: KEY_LENGTH / 32,
    iterations: ITERATION_COUNT,
    hasher: CryptoJS.algo.SHA256,
  });
}

export function encryptPassword(password: string): string {
  const key = deriveKey();
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv: iv,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  });

  const combined = iv.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}

export function decryptPassword(encryptedBase64: string): string {
  const key = deriveKey();
  const combined = CryptoJS.enc.Base64.parse(encryptedBase64);

  const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
  const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4), combined.sigBytes - 16);
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: ciphertext,
  });
  
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: iv,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  });

  return CryptoJS.enc.Utf8.stringify(decrypted);
}